import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client'
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';

import { COLORS } from './queries';

const Container = styled(View)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  margin: 20px;
`;

const Color = styled(View)`
  border-width: 1px;
  border-style: solid;
  border-color: black;
  width: 200px;
  height: 100px;
`;

const Sample = styled(View)`
  background-color: ${props => props.bg};
  width: 100%;
  height: 66px;
  margin-bottom: 10px;
  align-items: center;
`;

const SampleLabel = styled(Text)`
  color: ${props => props.fg};
  font-size: 24px;
`;

const Label = styled(Text)`
  color: ${props => props.fg};
`;

const Colors = () => {
  const { data } = useQuery(COLORS);

  return (
    <Container>
      <View style={{ width: '100%' }}>
        <Text>{data?.colors.length} colors available</Text>
      </View>
      {data?.colors.map(({ fg, bg }) => (
        <Color key={bg}>
          <Sample bg={bg}>
            <SampleLabel fg={fg}>{bg}</SampleLabel>
          </Sample>

          <Label>{bg}</Label>
        </Color>
      ))}
    </Container>
  );
};

export default Colors;
